import React, { useEffect, useState } from 'react';
import { Text } from '@fluentui/react-northstar';
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import { valueFormatTimeConvert } from '../../../helpers/dateTime';

const Timer = observer((props) => {
    const { startTime, testId } = props;

    const [callDuration, setCallDuration] = useState("00:00:00");

    const calculateTimerValue = (time) => {
        let callTime = Math.floor((Date.now() - new Date(time)) / 1000);
        if (callTime < 0) {
            // Don't allow negative times
            callTime = 0;
        }
        return valueFormatTimeConvert(callTime.toString());
    }

    useEffect(() => {
        // Set timer to update the call timer
        const timerId = setInterval(() => {
            const timerString = calculateTimerValue(startTime);

            setCallDuration(timerString);
        }, 250);

        return () => { clearInterval(timerId); }
    }, [startTime]);

    return (
        <Text
            className="timer-text"
            content={callDuration}
            size={props.size}
            timestamp={props.timestamp}
            data-testid={testId + "Duration"}
        />
    );
});

Timer.propTypes = {
    startTime: PropTypes.string,
    testId: PropTypes.string,
};

Timer.defaultProps = {
    startTime: "",
    testId: "",
}

export default Timer;